module.exports = __webpack_public_path__ + "static/media/emptyPrices.6fea62c3.png";